import dayjs from "dayjs";
import { forecastProcessingPath } from "../../components/scenario-modelling/TableData";

export function validateNumbers(inputValue: number, max: number) {
    if (inputValue > max) {
        inputValue = 100;
    } else if (inputValue < 0) {
        inputValue = 0;
    }
    return inputValue;
}

export function validateStartDate(startDate, processingPath, optimistic = false) {
    if (forecastProcessingPath.indexOf(processingPath) !== -1) {
        const startDateConstruction = dayjs(startDate);
        const FYStartDate = optimistic ? startDateConstruction.year() + '-07-01' : startDateConstruction.year() + '-07-02';
        return dayjs(FYStartDate);
    }
    return startDate
}

export function validateEndDate(endState, processingPath, optimistic = false) {
    if (forecastProcessingPath.indexOf(processingPath) !== -1) {
        const endDateConstruction = dayjs(endState);
        const FYEndDate = optimistic ? endDateConstruction.year() + '-06-30' : endDateConstruction.year() + '-07-01';
        return dayjs(FYEndDate);
    }
    return endState
}